import { CustomBrandComponents } from 'typings/brands'
import P66Faq from './P66FAQ'

/*
 * a custom component to get the FAQ Questions based on p66 card type
 * this return only p66 plcc as of now
 */
const FaqQuestions: CustomBrandComponents['FaqQuestions'] = ({
  i18n,
  access
}) => {
  // should add a switch case later based on card type and return the appropriate p66 question (p66plcc, p66dualcard etc)
  return <P66Faq i18n={i18n} {...access} />
}

export default FaqQuestions
